import { useQuery } from '@apollo/client';

import { CitiesDocument } from '../../graphql/queries/cities.gql-types';

export const useCities = (ids: string[]) => {
  const response = useQuery(CitiesDocument, {
    variables: {
      ids,
    },
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
  });

  return response;
};
